import { render, staticRenderFns } from "./EditPersonInfoDialog.vue?vue&type=template&id=61d6e9c4&scoped=true&"
import script from "./EditPersonInfoDialog.vue?vue&type=script&lang=js&"
export * from "./EditPersonInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditPersonInfoDialog.vue?vue&type=style&index=0&id=61d6e9c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d6e9c4",
  null
  
)

export default component.exports